export default __webpack_public_path__ + "static/media/insta-3.90db769c.jpg";